import React, { useEffect, useState } from 'react';
import { api, STATUS, fmtDate } from './api';

export const StatusBadge = ({ status }) => {
    const s = STATUS[status] || { label: status, tone: "muted", icon: "fas fa-circle" };
    return <span className={`sd-badge sd-badge--${s.tone}`}><i className={s.icon}></i> {s.label}</span>;
};

export const OutcomeBadge = ({ execution }) => {
    const e = execution;
    if (e.run_state === "deshecha" || e.run_state === "deshecha_con_restos") {
        return <span className="sd-badge sd-badge--muted"><i className="fas fa-undo"></i> Deshecha</span>;
    }
    if (e.run_state === "apagada") return <span className="sd-badge sd-badge--warn"><i className="fas fa-eye-slash"></i> Apagada</span>;
    if (e.outcome === "commiteada") return <span className="sd-badge sd-badge--ok"><i className="fas fa-check"></i> Copiada</span>;
    if (e.outcome === "revertida") {
        return <span className="sd-badge sd-badge--info"><i className="fas fa-flask"></i> {e.dry_run ? "Ensayo" : "Revertida"}</span>;
    }
    return <span className="sd-muted">—</span>;
};

// Historial de corridas: quién, cuándo, origen → destino, tipo, estado, resultado y duración.
const History = ({ onOpen }) => {
    const [rows, setRows] = useState(null);
    const [error, setError] = useState(null);

    const load = () => {
        api.executions().then((r) => {
            if (!r.ok) return setError(r.error);
            setRows(r.executions || []);
        });
    };

    useEffect(() => {
        load();
        const t = setInterval(load, 5000);
        return () => clearInterval(t);
    }, []);

    if (error) return <div className="rk-alert"><i className="fas fa-exclamation-circle"></i> {error}</div>;
    if (rows === null) return <div className="rk-empty"><i className="fas fa-spinner fa-spin"></i><p>Cargando historial…</p></div>;

    return (
        <div className="rk-table-card">
            {rows.length === 0 ? (
                <div className="rk-empty"><i className="fas fa-history"></i><p>Todavía no hay corridas.</p></div>
            ) : (
                <div className="rk-table-scroll">
                    <table className="rk-table">
                        <thead>
                            <tr>
                                <th>#</th><th>Fecha</th><th>Origen → destino</th><th>Tipo</th>
                                <th>Estado</th><th>Resultado</th><th>Elementos</th><th>Duración</th><th>Lanzada por</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((e) => (
                                <tr key={e.id} className="sd-row-click" onClick={() => onOpen(e.id)}>
                                    <td className="rk-cell-muted">{e.id}</td>
                                    <td>{fmtDate(e.created_at)}</td>
                                    <td>
                                        <strong>{e.source_name || `#${e.source_tenant_id}`}</strong>
                                        <span className="sd-muted"> → </span>
                                        <strong>{e.target_name || `#${e.target_tenant_id}`}</strong>
                                    </td>
                                    <td>{e.dry_run
                                        ? <span className="sd-badge sd-badge--muted"><i className="fas fa-flask"></i> Ensayo</span>
                                        : <span className="sd-badge sd-badge--info"><i className="fas fa-bolt"></i> Real</span>}
                                    </td>
                                    <td><StatusBadge status={e.status} /></td>
                                    <td><OutcomeBadge execution={e} /></td>
                                    <td>{(e.summary && e.summary.copia && e.summary.copia.total) || "—"}</td>
                                    <td>{e.duration ? `${e.duration}s` : "—"}</td>
                                    <td className="rk-cell-muted">{e.admin_email || "consola"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default History;
